/**
 * AuthManager - Basitleştirilmiş Kullanıcı Yöneticisi
 * Sadece localStorage ile kullanıcı adı saklanıyor
 */

const AuthManager = {
    username: null,
    character: "karakter1.png",
    user: null,
    profile: null,

    init: function () {
        console.log("👤 AuthManager: Initializing...");

        // localStorage'dan verileri al
        this.username = localStorage.getItem('playerName');
        this.character = localStorage.getItem('playerCharacter') || "karakter1.png";

        if (this.username) {
            console.log("👤 Welcome back:", this.username);
            this.syncWithTeable();
        } else {
            this.user = null;
            this.profile = null;
        }

        this.updateUI();
    },

    setUsername: function (name) {
        if (!name || name.trim().length < 2) {
            console.warn("⚠️ Username too short");
            return false;
        }

        this.username = name.trim();
        localStorage.setItem('playerName', this.username);

        // Fetch stats from Teable
        this.syncWithTeable();

        console.log("👤 Username set:", this.username);
        this.updateUI();
        return true;
    },

    syncWithTeable: async function (username) {
        if (!username) username = this.username;
        if (!username) return;

        console.log(`👤 AuthManager: Syncing with Teable for ${username}...`);

        try {
            const baseUrl = (window.multiplayer && window.multiplayer.HTTP_URL)
                ? window.multiplayer.HTTP_URL
                : window.location.origin;

            const response = await fetch(`${baseUrl}/api/auth/sync`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username })
            });

            const data = await response.json();
            if (data.success && data.user) {
                const u = data.user;
                this.user = { email: username + '@gaddar.com' };
                this.profile = {
                    username: u.username,
                    total_points: u.total_points,
                    correct_count: u.correct_count,
                    games_played: u.games_played,
                    wrong_count: (u.games_played || 0) - (u.correct_count || 0),

                    klasik_won: u.klasik_won || 0,
                    klasik_lost: u.klasik_lost || 0,
                    cark_won: u.cark_won || 0,
                    cark_lost: u.cark_lost || 0,
                    rulet_won: u.rulet_won || 0,
                    rulet_lost: u.rulet_lost || 0
                };

                // Sync localStorage for offline safety
                localStorage.setItem('stats_points', u.total_points || 0);
                localStorage.setItem('stats_won', u.correct_count || 0);
                localStorage.setItem('stats_played', u.games_played || 0);

                localStorage.setItem('stats_klasik_won', u.klasik_won || 0);
                localStorage.setItem('stats_klasik_lost', u.klasik_lost || 0);
                localStorage.setItem('stats_cark_won', u.cark_won || 0);
                localStorage.setItem('stats_cark_lost', u.cark_lost || 0);
                localStorage.setItem('stats_rulet_won', u.rulet_won || 0);
                localStorage.setItem('stats_rulet_lost', u.rulet_lost || 0);

                console.log("✅ Sync complete:", this.profile);
                this.updateUI();
                return true;
            }
        } catch (e) {
            console.error("❌ Sync failed:", e);
        }
        return false;
    },

    setCharacter: function (char) {
        this.character = char;
        localStorage.setItem('playerCharacter', char);
        console.log("👤 Character set:", char);
    },

    getUsername: function () {
        return this.username || `Misafir_${Math.random().toString(36).substring(2, 6)}`;
    },

    logout: function () {
        console.log("👤 AuthManager: Logging out...");
        this.username = null;
        this.user = null;
        this.profile = null;
        this.character = "karakter1.png";

        localStorage.removeItem('playerName');
        localStorage.removeItem('playerCharacter');
        localStorage.removeItem('stats_points');
        localStorage.removeItem('stats_won');
        localStorage.removeItem('stats_played');
        localStorage.removeItem('stats_klasik_won');
        localStorage.removeItem('stats_klasik_lost');
        localStorage.removeItem('stats_cark_won');
        localStorage.removeItem('stats_cark_lost');
        localStorage.removeItem('stats_rulet_won');
        localStorage.removeItem('stats_rulet_lost');

        this.updateUI();

        if (window.ProfileModal) window.ProfileModal.hide();

        console.log("✅ Logout successful.");
        if (window.SuccessModal) {
            window.SuccessModal.show("ÇIKIŞ YAPILDI", "Başarıyla çıkış yaptınız.", "TAMAM");
        } else {
            alert("Çıkış yapıldı.");
        }
    },

    updateUI: function () {
        const authBtn = document.getElementById('header-auth-btn');
        if (authBtn) {
            if (this.username) {
                authBtn.innerHTML = `
                    <span style="font-size:0.9rem; font-weight:800; color:var(--accent-gold); margin-right:5px;">${this.username}</span>
                    <span class="icon" style="font-size:1.1rem;">👤</span>
                `;
                authBtn.style.background = 'rgba(0,0,0,0.4)';
                authBtn.style.padding = '0 15px';
                authBtn.style.borderRadius = '50px';
                authBtn.style.border = '1px solid rgba(255,215,0,0.2)';
                authBtn.onclick = () => {
                    if (window.ProfileModal) window.ProfileModal.show();
                    else if (window.NameModal) window.NameModal.show();
                };
            } else {
                authBtn.innerHTML = `<span class="icon">👤</span> <span class="label" style="font-size:0.8rem;">İSİM GİR</span>`;
                authBtn.onclick = () => {
                    if (window.NameModal) window.NameModal.show();
                };
            }
        }
    },

    checkAuthOrOpenModal: function () {
        if (window.NameModal) {
            window.NameModal.show();
        }
    },

    addStats: async function (points, correct, wrong, gameMode = null) {
        if (!this.username) return;

        // Update local profile
        if (this.profile) {
            this.profile.total_points = (this.profile.total_points || 0) + points;
            this.profile.correct_count = (this.profile.correct_count || 0) + correct;
            this.profile.games_played = (this.profile.games_played || 0) + (correct + wrong);
            this.profile.wrong_count = this.profile.games_played - this.profile.correct_count;

            if (gameMode) {
                if (gameMode === 'klasik') {
                    this.profile.klasik_won = (this.profile.klasik_won || 0) + correct;
                    this.profile.klasik_lost = (this.profile.klasik_lost || 0) + wrong;
                } else if (gameMode === 'wheel') {
                    this.profile.cark_won = (this.profile.cark_won || 0) + correct;
                    this.profile.cark_lost = (this.profile.cark_lost || 0) + wrong;
                } else if (gameMode === 'roulette') {
                    this.profile.rulet_won = (this.profile.rulet_won || 0) + correct;
                    this.profile.rulet_lost = (this.profile.rulet_lost || 0) + wrong;
                }
            }
        }

        // Update local storage 
        const currentPoints = parseInt(localStorage.getItem('stats_points') || '0', 10);
        const currentWon = parseInt(localStorage.getItem('stats_won') || '0', 10);
        const currentPlayed = parseInt(localStorage.getItem('stats_played') || '0', 10);

        localStorage.setItem('stats_points', currentPoints + points);
        localStorage.setItem('stats_won', currentWon + correct);
        localStorage.setItem('stats_played', currentPlayed + (correct + wrong));

        if (gameMode && this.profile) {
            localStorage.setItem(`stats_${gameMode === 'wheel' ? 'cark' : gameMode === 'roulette' ? 'rulet' : 'klasik'}_won`, this.profile[`${gameMode === 'wheel' ? 'cark' : gameMode === 'roulette' ? 'rulet' : 'klasik'}_won`]);
            localStorage.setItem(`stats_${gameMode === 'wheel' ? 'cark' : gameMode === 'roulette' ? 'rulet' : 'klasik'}_lost`, this.profile[`${gameMode === 'wheel' ? 'cark' : gameMode === 'roulette' ? 'rulet' : 'klasik'}_lost`]);
        }

        // Sync with backend
        try {
            const baseUrl = (window.multiplayer && window.multiplayer.HTTP_URL) ? window.multiplayer.HTTP_URL : window.location.origin;
            await fetch(`${baseUrl}/api/auth/updateStats`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    username: this.username,
                    points: points,
                    correct: correct,
                    games: correct + wrong,
                    gameMode: gameMode
                })
            });
            console.log(`✅ Stats synced with server. [Mode: ${gameMode || 'genel'}]`);
        } catch (e) {
            console.error("❌ Failed to sync stats to server:", e);
        }
    },

    isAdmin: function () {
        return false;
    }
};

window.AuthManager = AuthManager;
